import { render, staticRenderFns } from "./template-email.vue?vue&type=template&id=170e9dc3&scoped=true&"
import script from "./template-email.vue?vue&type=script&lang=js&"
export * from "./template-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170e9dc3",
  null
  
)

export default component.exports